import React from 'react';
import classnames from 'classnames';

// Components
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './TableLoading.scss';

type Props = {
  tableId: string;
  showBorder: boolean;
  countToRender?: number;
};

const TableLoading = ({ tableId, showBorder = true, countToRender = 6 }: Props) => {
  const baseClassName = 'TableLoading';
  const classes = classnames(`${baseClassName}__tr`, showBorder ? `${baseClassName}__tr--bordered` : '');

  return (
    <tbody>
      {Array.from({ length: countToRender }, (_, k) => (
        <tr key={`${tableId}--loading-${k}`} className={classes}>
          <td className={`${baseClassName}__tr__td`} colSpan={100}>
            <LoadingShimmer width="100%" height="16px" shape="rectangle" />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default TableLoading;
